import React from 'react'
import styled from 'styled-components'
import { Collapse } from 'reactstrap'

import { FaAngleDown } from 'react-icons/fa'

const Container = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`

const Content = styled.div`
  margin-top: 2rem;
`

const Step = styled.span`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.main};
  border-radius: 100%;
  color: ${({ theme }) => theme.colors.text.main};
  display: flex;
  font-size: 1.75rem;
  font-weight: bold;
  height: 3.25rem;
  justify-content: center;
  margin-right: 12px;
  padding: 12px;
  width: 3.25rem;
`

const Title = styled.span`
  color: ${({ theme }) => theme.colors.text.gray};
  font-size: 1.80rem;
  font-weight: bold;
  margin-right: 12px;
`

const StyledAngleDown = styled(FaAngleDown)`
  color: ${({ theme }) => theme.colors.text.gray};
  height: auto;
  transform: ${({ selected }) => selected ? 'rotate(180deg)' : 'none'};
  transition: transform 0.5s;
  width: 32px;
`

class CollapsibleStep extends React.PureComponent {
  static defaultProps = {
    collapsed: null,
    onChange: null,
    step: ''
  }

  state = {
    collapsed: true
  }

  get collapsed() {
    if (this.props.collapsed !== null) {
      return this.props.collapsed
    }

    return this.state.collapsed
  }

  handleClick = () => {
    if (this.props.onChange === null) {
      this.setState({
        collapsed: !this.collapsed
      })
    } else {
      this.props.onChange(!this.collapsed)
    }
  }

  renderStep() {
    if (this.props.step) {
      return (
        <Step>
          { this.props.step }
        </Step>
      )
    }

    return null
  }

  render() {
    return (
      <div className={ this.props.className }>
        <Container onClick={ this.handleClick }>
          { this.renderStep() }
          <Title>
            { this.props.title }
          </Title>
          <StyledAngleDown selected={ !this.collapsed } />
        </Container>
        <Collapse
          isOpen={ !this.collapsed }
        >
          <Content>
            { this.props.children }
          </Content>
        </Collapse>
      </div>
    )
  }
}

export default CollapsibleStep



// WEBPACK FOOTER //
// ./src/components/atoms/CollapsibleStep/CollapsibleStep.js